import skillImg from '../assets/img/skills/code.svg';
import { computeStatus, computeDuration, computeExperienceLevel } from '../helpers/compute.js';
import useMoment from '../helpers/moment.js';
import { months } from '../data/utils';

export default {
    computeStatus,
    computeDuration,
    computeExperienceLevel,
    useMoment,
    hoursNeeded: type =>
        type == 2 ? '40 hours or more (Full-Time)' : type == 3 ? 'Less than 40 hours (Part-Time)' : 'Not Specified',
    copy(link) {
        const vm = this;

        if (!navigator.clipboard) return;

        navigator.clipboard.writeText(link).then(
            function() {
                setTimeout(() => {
                    vm.copied = false;
                }, 3000);

                vm.copied = true;
            },
            function(err) {
                console.error('Async: Could not copy text: ', err);
            },
        );
    },
    getSkillImg(skill = '') {
        if (!skill) return skillImg;
        try {
            let logo_name = skill.toLowerCase();
            logo_name = logo_name.split(' ').join('-');
            return require(`@/assets/img/skills/${logo_name.toLowerCase()}.png`);
        } catch (e) {
            if (e.code === 'MODULE_NOT_FOUND') return skillImg;
        }
    },
    addMinutes: (date, minutes) => new Date(new Date(date).getTime() + minutes * 60000),
    dateHasPassed: date => Math.floor((new Date() - new Date(date)) / 60000) > 2,
    formatTime(date) {
        let hours = date.getHours();
        let minutes = date.getMinutes();
        let ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        return `${hours}:${minutes} ${ampm}`;
    },
    formatDate(date) {
        const sameDay = this.datesAreOnSameDay(new Date(date), new Date());
        if (sameDay) return 'Today - ' + this.formatTime(new Date(date));
        return `${months[new Date(date).getMonth()]} ${new Date(date).getDate()}, ${String(new Date(date)).slice(
            11,
            15,
        )}`;
    },
    formatAmount: amount =>
        amount
            ? Number(amount).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
              })
            : '0.00',
    validateEmail: email => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email),
    checkEmptyProperties(obj) {
        let count = 0;
        for (let i in obj) {
            if (!obj[i] || !String(obj[i]).length) count++;
        }
        return count ? false : true;
    },
};
